import { useState } from 'react';
export const useValidationError = errors => {
  const [errorState, setErrorState] = useState(errors);
  const setErrors = errors => errors.forEach(error => setErrorState(prevErrors => {
    return [...prevErrors.filter(({
      name: fieldName
    }) => fieldName !== error.name), error];
  }));
  const setFieldErrors = (errors, field) => setErrorState(prevErrors => {
    return [...prevErrors.filter(({
      name: fieldName
    }) => fieldName !== field), ...errors];
  });
  const resetErrors = () => setErrorState([]);
  return {
    errors: errorState,
    setErrors,
    setFieldErrors,
    resetErrors
  };
};